module.exports = __webpack_public_path__ + "media/images/outlook-icon-631f5d51d9b6097820deaaf2edeaefd7.svg";